import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { searchDeviceMgmt, getClientShipList, getClientShippingCompanyList } from "../Actions/DeviceManagement";
import { getShipnameList, getCompanynameList } from "../Actions/HelpersAPI";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import Moment from "moment";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import { is } from "date-fns/locale";

let user = JSON.parse(localStorage.getItem("currentUser"));

const searchData = {
  deviceId: "",
  make: "",
  modal: "",
  manufacturingDate: "",
  lastCalibrationDate: "",
  companyName: "",
  shipName: "",
  maximumLimit: "",
  pageNumber: 1,
  pageSize: 25,
  isActive: null
};

class AddDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedManufacturingDate: "",
      SelectedFromDate: "",
      manufacturingDate: "",
      fromDate: "",
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: false,
      searchData: {
        id: "",
        make: "",
        model: "",
        manufacturingDate: "",
        lastCalibrationDate: "",
        nextCalibrationDate: "",
        companyName: "",
        shipName: "",
        createdBy: user.email,
        maximumLimit: "",
        isActive: null
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleManufacturingDateChange = this.handleManufacturingDateChange.bind(
      this
    );
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openManufacturingDatePicker = this.openManufacturingDatePicker.bind(
      this
    );
    this.handleOpenNextCallibration = this.handleOpenNextCallibration.bind(this);
    this.handleNextCallibrationDateChange = this.handleNextCallibrationDateChange.bind(this);
  }
  componentDidMount() {
    // this.props.dispatch(getShipnameList());
    this.props.dispatch(getCompanynameList());
  }


  handleFromDateChange(date) {
    const momentDate = Moment(date);
    const nextDate = momentDate.add(1, 'years');
    // this.state.searchData.lastCalibrationDate = Moment(
    //   new Date(Date.parse(date))
    // ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
      searchData: {
        ...this.state.searchData,
        lastCalibrationDate: Moment(new Date(Date.parse(date))).format("YYYY-MM-DD"),
        nextCalibrationDate: Moment(new Date(Date.parse(nextDate))).format("YYYY-MM-DD")
      }
    });
  }

  handleManufacturingDateChange(date) {
    this.state.searchData.manufacturingDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedManufacturingDate: date,
      manufacturingDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openManufacturingDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      manufacturingDatePickerIsOpen: !this.state.manufacturingDatePickerIsOpen,
    });
  }

  onclickShipname = () => {
    if (this.state.searchData?.companyName?.trim().length > 0) {
      if (this.props.ClientShipLists2?.length > 0) {

      } else {
        toast.error("There is no ships assigned for this company.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please choose the company to select the ship.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "companyName") {
      this.state.searchData[nodeName] = e.target.value;
      this.state.searchData.shipName = "";
      this.props.dispatch(getClientShippingCompanyList(e.target.value));
    }
    if (nodeName === "maximumLimit") {
      var pattern = /^[0-9]*\.?[0-9]*$/;
      if (pattern.test(e.target.value)) {
        const phone = e.target.validity.valid ? e.target.value : this.state.searchData.maximumLimit;
        this.state.searchData[nodeName] = phone;
        this.setState({});
      }
    } else {
      this.state.searchData[nodeName] = e.target.value;
      this.setState({});
    }
  }

  handleBlur() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: false
    });
  }

  addDevice() {
    const { dispatch } = this.props;
    if (this.state.searchData.companyName !== "" && this.state.searchData.id !== "" && this.state.searchData.lastCalibrationDate !== "" && this.state.searchData.nextCalibrationDate !== "" &&
      this.state.searchData.make !== "" && this.state.searchData.model !== "" && this.state.searchData.shipName !== "" && this.state.searchData.manufacturingDate !== "" && this.state.searchData.maximumLimit !== "" && this.state.searchData.isActive !== undefined && this.state.searchData.isActive !== null) {
      var decimals = this.state.searchData.maximumLimit - Math.floor(this.state.searchData.maximumLimit);
      if (decimals === 0) {
        this.state.searchData.maximumLimit = Math.round(this.state.searchData.maximumLimit);
        this.setState({})
      } else {
        this.state.searchData.maximumLimit = Number(this.state.searchData.maximumLimit);
        this.setState({})
      }

      let url = `${API.PostDevice}`;
      axios
        .post(url, this.state.searchData)
        .then((response) => {
          if (response.status === 500) {
            swal("Error!", "Error when adding the data. Try again.", "warning");
          } else {
            this.cancel();
            toast.success("Added Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            dispatch(searchDeviceMgmt(searchData));
            dispatch({
              type: "PostDeviceDetailSuccess",
              data: response.data,
            });
          }
        })
        .catch((error) => {
          swal("Error!", "Something went wrong. Please try again.", "warning");
          dispatch({
            type: "PostDeviceDetailFailure",
            error: "ERROR",
          });
        });
    } else if (this.state.searchData.id === "") {
      swal('Error!', 'Device Id is mandatory', 'warning');
    }
    else if (this.state.searchData.make === "") {
      swal('Error!', 'Make is mandatory', 'warning');
    }
    else if (this.state.searchData.model === "") {
      swal('Error!', 'Model is mandatory', 'warning');
    } else if (this.state.searchData.manufacturingDate === "") {
      swal('Error!', 'Manufacturing Date is mandatory', 'warning');
    }
    else if (this.state.searchData.lastCalibrationDate === "") {
      swal('Error!', 'Last Calibration Date is mandatory', 'warning');
    }
    else if (this.state.searchData.nextCalibrationDate === "") {
      swal('Error!', 'Next Calibration Date is mandatory', 'warning');
    }
    else if (this.state.searchData.companyName === "") {
      swal('Error!', 'Company Name is mandatory', 'warning');
    } else if (this.state.searchData.shipName === "") {
      swal('Error!', 'Ship Name is mandatory', 'warning');
    } else if (this.state.searchData.maximumLimit === "") {
      swal('Error!', 'Maximum Limit is mandatory', 'warning');
    }
    else if (this.state.searchData.isActive === undefined || this.state.searchData.isActive === null) {
      swal('Error!', 'Is Active is mandatory', 'warning');
    }
  }

  cancel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Device");
  };

  BacktoPrevious() {
    this.props.history.goBack();
  }

  handleOpenNextCallibration() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: !this.state.nextCalibrationDateIsOpen
    });
  }

  handleNextCallibrationDateChange(date) {
    this.setState({
      searchData: {
        ...this.state.searchData,
        nextCalibrationDate: Moment(
          new Date(Date.parse(date))
        ).format("YYYY-MM-DD")
      },
      fromDatePickerIsOpen: false,
      manufacturingDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: false
    })
  }

  render() {
    const { showSidePane, ShipNameList, CompanyList, ClientShipLists2 } = this.props;
    return (
      <div className="full-height pt-3">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div className="row ">
                  <div className="col-lg-12">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white", border: "0px" }}
                    >
                      <div className="card-body">
                        <h5 className="card-title mt-2 ml-1 pl-3" style={{ color: "092a51" }}>
                          Add Device
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">ID</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="id"
                            placeholder="ID"
                            value={this.state.searchData.id}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Make</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="make"
                            placeholder="Make"
                            value={this.state.searchData.make}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Model</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="model"
                            placeholder="Model"
                            value={this.state.searchData.model}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Manufacturing Date</label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                          >
                            <input
                              type="text"
                              value={this.state.searchData.manufacturingDate}
                              className="form-control date-picker"
                              placeholder="Manufacturing Date"
                              name="manufacturingDate"
                            ></input>
                            <DatePicker
                              onChange={this.handleManufacturingDateChange}
                              open={this.state.manufacturingDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement="top-end"
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.openManufacturingDatePicker}
                            >
                              <button
                                className="btn btn-default"
                                style={{ height: "100%" }}
                              >
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Last Calibration Date</label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                          >
                            <input
                              type="text"
                              value={this.state.searchData.lastCalibrationDate}
                              className="form-control date-picker"
                              placeholder="Last Calibration Date"
                              name="lastCalibrationDate"
                            ></input>
                            <DatePicker
                              onChange={this.handleFromDateChange}
                              open={this.state.fromDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement="top-end"
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.openFromDatePicker}
                            >
                              <button
                                className="btn btn-default"
                                style={{ height: "100%" }}
                              >
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Next Calibration Date</label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                          >
                            <input
                              type="text"
                              value={this.state.searchData.nextCalibrationDate}
                              className="form-control date-picker"
                              placeholder="Next Calibration Date"
                              name="nextCalibrationDate"
                            ></input>
                            <DatePicker
                              onChange={this.handleNextCallibrationDateChange}
                              open={this.state.nextCalibrationDateIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement="top-end"
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.handleOpenNextCallibration}
                            >
                              <button
                                className="btn btn-default"
                                style={{ height: "100%" }}
                              >
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Company Name</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="companyName"
                            value={this.state.companyName}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">Select Company Name</option>
                            {CompanyList &&
                              CompanyList.map((company) => (
                                <option value={company.clientName}>
                                  {company.clientName}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Ship Name</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="shipName"
                            value={this.state.shipName}
                            onClick={this.onclickShipname}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">Select Ship Name</option>

                            {ClientShipLists2 &&
                              ClientShipLists2.map((ships) => (
                                <option value={ships.shipName}>
                                  {ships.shipName}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Maximum Limit</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="maximumLimit"
                            placeholder="Maximum Limit"
                            value={this.state.searchData.maximumLimit}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        {/* Is active added */}
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                          <label className="form-label required">Is Active</label>
                          <br></br>
                          <div className="d-flex">
                            <input
                              style={{ height: '20px', width: '20px' }}
                              type="checkbox"
                              name="isActive"
                              id="activeyes"
                              className="mr-2"
                              checked={this.state.searchData?.isActive === true}
                              onChange={() =>
                                this.setState((prevState) => ({
                                  searchData: {
                                    ...prevState.searchData,
                                    isActive: true
                                  }
                                }))
                              }
                            ></input>
                            <label htmlFor="activeyes" className="form-label mr-3 mt-0">Yes</label>
                            <input
                              style={{ height: '20px', width: '20px' }}
                              type="checkbox"
                              name="isActiveNo"
                              id="activeno"
                              className="mr-2"
                              checked={this.state.searchData?.isActive === false}
                              onChange={() =>
                                this.setState((prevState) => ({
                                  searchData: {
                                    ...prevState.searchData,
                                    isActive: false
                                  }
                                }))
                              }
                            ></input>
                            <label htmlFor="activeno" className="form-label mt-0">No</label>
                          </div>
                        </div>
                        <div className={showSidePane ? "col-lg-6" : "col-lg-8"}>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.addDevice()}
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.cancel()}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* <div className={"col-lg-12"}>
                    <br></br>
                    <div
                      className="search-btn-col my-3"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addDevice()}
                      >
                        Submit
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.cancel()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {

  return {
    ShipNameList: state.UserManageReducer.ShipNameList,
    CompanyList: state.UserManageReducer.CompanyList,
    showSidePane: state.SidePanReducer.sidePan || false,
    ClientShipLists2: state.DeviceManagementReducer.ClientShipLists2 || []
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddDevice)
);
